<div class="app-form-key-wrapper">
    <ng-container *ngIf="formReady">
        <app-form-by-key [formKey]="formKey" [submission]="submission" [readOnly]="viewOnly"
            [enableFormSubmit]="enableFormSubmit" (onChange)="onChange($event)"></app-form-by-key>
    </ng-container>
</div>